// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    direction = "direction",
    alignItems = "alignItems",
    justifyContent = "justifyContent",
}

export enum AlignementDirection {
    Row = "row",
    Column = "column",
}

export enum AlignItems {
    Start = "flex-start",
    Center = "center",
    End = "flex-end",
}

export enum JustifyContent {
    SpaceBetween = "space-between",
    SpaceEvenly = "space-evenly",
    Center = "center",
    Start = "flex-start",
    End = "flex-end",
}

interface Props extends WidgetProps {
    fields: {
        [fields.direction]: string;
        [fields.alignItems]: string;
        [fields.justifyContent]: string;
    };
}

const Aligner: FC<Props> = ({ id, fields: { direction, alignItems, justifyContent } }) => {
    const alignerStyles = css`
        > [class*="Wrapper"] {
            display: flex;
            flex-direction: ${direction};
            align-items: ${alignItems};
            justify-content: ${justifyContent};
        }
    `;

    return (
        <StyledWrapper css={alignerStyles}>
            <Zone contentId={id} zoneName={`Aligner-${id}`} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: Aligner,
    definition: {
        group: "Basic",
        displayName: "Aligner",
        fieldDefinitions: [
            {
                name: fields.direction,
                displayName: "Direction",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Row",
                        value: AlignementDirection.Row,
                    },
                    {
                        displayName: "Column",
                        value: AlignementDirection.Column,
                    },
                ],
                defaultValue: AlignementDirection.Row,
                fieldType: "General",
            } as DropDownFieldDefinition<string>,
            {
                name: fields.alignItems,
                displayName: "Align Items",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "Start",
                        value: AlignItems.Start,
                    },
                    {
                        displayName: "Center",
                        value: AlignItems.Center,
                    },
                    {
                        displayName: "End",
                        value: AlignItems.End,
                    },
                ],
                defaultValue: AlignementDirection.Row,
                fieldType: "General",
            } as DropDownFieldDefinition<string>,
            {
                name: fields.justifyContent,
                displayName: "Justify Content",
                editorTemplate: "DropDownField",
                options: [
                    {
                        displayName: "SpaceBetween",
                        value: JustifyContent.SpaceBetween,
                    },
                    {
                        displayName: "SpaceEvenly",
                        value: JustifyContent.SpaceEvenly,
                    },
                    {
                        displayName: "Center",
                        value: JustifyContent.Center,
                    },
                    {
                        displayName: "Start",
                        value: JustifyContent.Start,
                    },
                    {
                        displayName: "End",
                        value: JustifyContent.End,
                    },
                ],
                defaultValue: AlignementDirection.Row,
                fieldType: "General",
            } as DropDownFieldDefinition<string>,
        ],
    },
};

export default widgetModule;
